export default __webpack_public_path__ + "static/media/group@2x.8eb6d42c.png";